"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tabs", {
    enumerable: true,
    get: function() {
        return Tabs;
    }
});
var Tabs = {
    baseStyle: {
        tablist: {
            columnGap: "0.25rem"
        },
        tab: {
            _focus: {
                boxShadow: "none"
            }
        }
    },
    sizes: {
        sm: function(param) {
            var theme = param.theme;
            return {
                tab: theme.textStyles["text-body-medium"]
            };
        },
        md: function(param) {
            var theme = param.theme;
            return {
                tab: theme.textStyles["text-body-medium"]
            };
        },
        lg: function(param) {
            var theme = param.theme;
            return {
                tab: theme.textStyles["text-body-medium"]
            };
        }
    },
    variants: {
        line: {
            color: "text-secondary",
            tablist: {
                border: 0
            },
            tab: {
                _selected: {
                    borderColor: "primary-default",
                    color: "text-primary"
                }
            }
        },
        rounded: {
            tab: {
                borderRadius: "radii-6",
                color: "text-secondary",
                _selected: {
                    backgroundColor: "background-action-active",
                    color: "text-link-primary-default"
                }
            }
        }
    },
    defaultProps: {
        variant: "line"
    }
};
